import { useEffect } from 'react'
import { useNavigation } from 'expo-router'
import { isAppFlowReset } from '../navigation/appFlowReset'

export const usePreventBack = ({ back }: { back?: boolean | undefined }) => {
  const navigation = useNavigation()
  useEffect(() => {
    if (back !== false) {
      return
    }
    const unsubscribe = navigation.addListener('beforeRemove', (e) => {
      if (isAppFlowReset(e.data.action)) {
        return
      }
      // Prevent default behavior of leaving the screen
      if (e.data.action.type === 'GO_BACK' || e.data.action.type === 'RESET') {
        e.preventDefault()
      }
    })
    return unsubscribe
  }, [navigation, back])
}
